import api from './config';

const NOTES_API_URL = `${process.env.REACT_APP_SERVER_URL}/calendarNote`;

export const fetchNote = async (user: string, type: string, date: string) => {
  const res = await api.get(`${NOTES_API_URL}/${type}/${date}?user=${user}`);
  return res.data;
};

export const saveNote = async (user: string, type: string, date: string, content: string) => {
  const res = await api.post(`${NOTES_API_URL}`, {
    user,
    type,
    date,
    content,
  });
  return res.data;
};
